/* eslint-disable max-len */

import type { FC } from 'react';
import React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const TestIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M11 5C11 4.44772 11.4477 4 12 4H20C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6L20 12.7344L27.0133 25.0077C27.7752 26.341 26.8125 28 25.2768 28H6.72317C5.18753 28 4.22479 26.341 4.98668 25.0077L12 12.7344V6C11.4477 5.99999 11 5.55228 11 5ZM14 6H18V12.7344C18 13.0825 18.0908 13.4245 18.2635 13.7267L20.7054 18H11.2946L13.7365 13.7267C13.9092 13.4245 14 13.0825 14 12.7344V6ZM10.1517 20L6.72317 26H25.2768L21.8482 20H10.1517Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
